export class EnaioUserPermissions {
}
